import clsx from 'clsx';
import styles from './FormGroup.module.scss';

export type FormGroupProps = {row?: boolean};

export const FormGroup = ({
  className,
  children,
  row,
  ...props
}: Partial<React.HTMLProps<HTMLDivElement>> & FormGroupProps) => (
  <div
    className={clsx(className, styles.formGroup, row && styles.row)}
    {...props}
  >
    {children}
  </div>
);
